import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import SelectPicker from '../../../components/SelectPicker';
import FormInput from '../../../components/FormInput';
import {ModelListSelect} from 'vue-search-select';

export default {
    components: {Datepicker, SelectPicker, FormInput, ModelListSelect},
    data() {
        return {
            date_from: null,
            date_to: null,
            reverser: null,
            cashier: null,
            percent: null,
            daily: false,
            monthly: false,
            sortPassengers: '',
            sortPassengersDir: 1,
            result: [],
            percents: [],
            cashiers: [],
            total: {},
            loadingState: false,
            fromError: false,
            toError: false,
            inputClass: ['form-control base_input'],
        }
    },
    created() {
        this.$api.get('reports.reversals-report-percent').then(res => {
            this.percents = res.data;
        });
        this.$api.get('reports.reversals-report-cashiers').then(res => {
            this.cashiers = res.data;
        });
    },
    methods: {
        changeSort(sort) {
            if (this.sortPassengers === sort) {
                this.sortPassengersDir = this.sortPassengersDir === 0 ? 1 : 0
            } else {
                this.sortPassengers = sort;
                this.sortPassengersDir = 0;
            }
        },
        reportDaily() {
            this.daily = true;
            this.monthly = false;

            this.date_from = new Date();
            this.date_to = new Date();
            this.makeRequest({daily: true});
        },
        reportMonthly() {
            this.monthly = true;
            this.daily = false;

            var date = new Date();
            this.date_from = new Date(date.getFullYear(), date.getMonth(), 1);
            this.date_to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            this.makeRequest({monthly: true});
        },
        reportCustom() {
            this.daily = false;
            this.monthly = false;

            if (this.date_from && this.date_to) {
                this.inputClass.splice(1, 1);
                let fromDate = this.$moment(this.date_from).startOf('day').format('Y-MM-DD');
                let toDate = this.$moment(this.date_to).endOf('day').format('Y-MM-DD');
                this.makeRequest({from: fromDate, to: toDate});
            } else {
                if (!this.date_from) {
                    this.fromError = true;
                }
                if (!this.date_to) {
                    this.toError = true;
                }
                this.inputClass.push('is-invalid');
            }
        },
        exportToExcel() {
            let fileName = 'Отчет_о_возврате' + this.$moment(this.fromDate).format('DDMMYYYY') + '-' + this.$moment(this.toDate).format('DDMMYYYY') + '.xls';
            this.$api.download('xls.reversals-reports', {
                from: this.$moment(this.date_from),
                to: this.$moment(this.date_to),
                monthly: this.monthly ? 1 : 0,
                daily: this.daily ? 1 : 0,
                percent: (this.percent || this.percent===0) ? this.percent : null,
                cashier: (this.cashier) ? this.cashier : null,
                reverser: (this.reverser) ? this.reverser : null,
        }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        makeRequest(params) {
            this.loadingState = true;
            if (this.percent || this.percent===0) params.percent = this.percent;
            if (this.cashier) params.cashier = this.cashier;
            if (this.reverser) params.reverser = this.reverser;

            this.$api.post('reports.reversals-reports', params).then(res => {
                console.log(res.data);
                this.result = res.data;
                // this.calculateTotal();
            }).finally(() => {
                this.loadingState = false;
            })
        },
        /*calculateTotal() {
            this.total.passengers = this.result.reduce((sum, a) => sum + a.passengers,0);
            this.total.baggage = this.result.reduce((sum, a) => sum + a.baggage,0);
            this.total.amount = this.result.reduce((sum, a) => sum + a.amount,0);
            this.total.terminal_amount = this.result.reduce((sum, a) => sum + a.terminal_amount,0);
        },*/
        printData() {
            let fontSize = this.$refs.printTable.style.fontSize;
            this.$refs.printTable.style.fontSize = '13.5px';
            this.displayNoneLoop = false;
            let mywindow = window.open('', 'PRINT');
            mywindow.document.write('<html><head><title>' + document.title + '</title>');
            mywindow.document.write('<link rel="stylesheet" href="/css/lib.css" />');
            mywindow.document.write('<link rel="stylesheet" href="/css/app.css" />');
            mywindow.document.write('<link rel="stylesheet" href="/print.css" />');
            mywindow.document.write('</head><body >');
            mywindow.document.write(document.getElementById('table').innerHTML);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus();
            this.$refs.printTable.style.fontSize = fontSize;

            setTimeout(() => {
                mywindow.print();
                mywindow.close();
            }, 1000)
        }
    },
    computed: {
        sortedPassengers() {
            let sorted = this.result.sort((a, b) => {
                if (this.sortPassengers === 'passenger_name') {
                    let nameA = a.passenger_name.toUpperCase();
                    let nameB = b.passenger_name.toUpperCase();
                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                } else if (this.sortPassengers === 'reverser_name') {
                    let nameA = a.reverser_name.toUpperCase();
                    let nameB = b.reverser_name.toUpperCase();
                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                } else if (this.sortPassengers === 'cashier_name') {
                    let nameA = a.cashier_name.toUpperCase();
                    let nameB = b.cashier_name.toUpperCase();
                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                } else if (this.sortPassengers === 'route_name') {
                    let nameA = a.route_name.toUpperCase();
                    let nameB = b.route_name.toUpperCase();
                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                } else if (this.sortPassengers === 'percent') {
                    if (a.percent < b.percent) return -1;
                    if (a.percent > b.percent) return 1;
                    return 0;
                } else if (this.sortPassengers === 'seat_number') {
                    if (a.seat_number < b.seat_number) return -1;
                    if (a.seat_number > b.seat_number) return 1;
                    return 0;
                } else if (this.sortPassengers === 'ticket_price') {
                    if (a.ticket_price < b.ticket_price) return -1;
                    if (a.ticket_price > b.ticket_price) return 1;
                    return 0;
                } else if (this.sortPassengers === 'reverse_amount') {
                    if (a.reverse_amount < b.reverse_amount) return -1;
                    if (a.reverse_amount > b.reverse_amount) return 1;
                    return 0;
                } else if (this.sortPassengers === 'trip_time') {
                    return new Date(b.trip_time) - new Date(a.trip_time);
                } else if (this.sortPassengers === 'sold_time') {
                    return new Date(b.sold_time) - new Date(a.sold_time);
                } else if (this.sortPassengers === 'reversal_time') {
                    return new Date(b.reversal_time) - new Date(a.reversal_time);
                } else {
                    return 0;
                }
            });
            if (this.keyword) {
                let keyword = this.keyword.toLowerCase();
                sorted = sorted.filter((item) => {
                    return (item.full_name && item.full_name.toLowerCase().includes(keyword)) ||
                        (item.trip && item.trip.route.name && item.trip.route.name.toLowerCase().includes(keyword)) ||
                        (item.phone && item.phone.toLowerCase().includes(keyword));
                });
            }
            if (this.selectedPassengerStatus !== null) {
                if (this.selectedPassengerStatus === -1) {
                    sorted = sorted.filter(item => {
                        return !(item.status === 0 || item.status === 1 || item.status === 2 || item.status === 3 || item.status === 4)
                    });
                } else {
                    sorted = sorted.filter(item => item.status === this.selectedPassengerStatus);
                }
            }

            return this.sortPassengersDir === 1 ? sorted.reverse() : sorted;
        }
    },
    filters: {
        moneyFormat(num) {
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
        },
    }
}
